/**
*****************************************
*										*
* NAGARRO  - CSX - CONFIDENTIAL         *
*										*
*****************************************
*/
import * as _ from 'lodash';

import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';

import { AppUtilityService } from './../../../core/services/app-utility.service';
import { ConfigService } from '../../../core/services/config.service';
import { StaticDataStoreService } from './../../../core/services/static-datastore.service';
import { TerminalCommonInfo } from '../../../core/model/terminal-common-info.model';
import { TrainData } from '../../../core/model/train-data.model';

/**
 * @export
 * @class LmsTrainRouteComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-train-route',
  templateUrl: './lms-train-route.component.html',
  styleUrls: ['./lms-train-route.component.scss']
})
export class LmsTrainRouteComponent implements OnInit, OnDestroy, OnChanges {

  @Input() trainData: TrainData;
  trainLabel: any;
  trainTypeValue: string;
  originTerminalValue: string;
  currentTerminalValue: string;
  nextTerminalValue: string;
  destinationTerminalValue: string;
  currentCrewTime: string;
  currentCrewLabel: string;
  nextCrewTime: string;
  nextCrewLabel: string;
  isNextDestinationSame: boolean;
  /**
   * Creates an instance of LmsTrainRouteComponent.
   * @param {ConfigService} configService
   * @memberOf LmsTrainRouteComponent
   */
  constructor(private configService: ConfigService,
    private staticDataStoreService: StaticDataStoreService,
    private appUtilityService: AppUtilityService) {
    this.trainLabel = this.configService.getConfigData().trainLabel;
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LmsTrainRouteComponent
   */
  ngOnInit() {
    this.getCrewInformation();
    this.checkNextDestinationSame();
    if (this.trainData && this.trainData.trainType) {
      if (this.trainData.trainType.trim().toUpperCase() === 'TI') {
        this.trainTypeValue = 'Train Inbound Arrived';
      } else if (this.trainData.trainType.trim().toUpperCase() === 'TO') {
        this.trainTypeValue = 'Train Ordered';
      } else if (this.trainData.trainType.trim().toUpperCase() === 'TD') {
        this.trainTypeValue = 'Train Departed';
      }
    }
  }

  /**
   * Set origin, current, next and destination terminal mnemonic with city and state.
   * @memberOf LmsTrainRouteComponent
   */
  ngOnChanges() {
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (commonopsPicklist) {
      if (this.trainData && this.trainData.originTerminal) {
        this.originTerminalValue = this.getTerminalInfo(commonopsPicklist, this.trainData.originTerminal.trim().toUpperCase());
      }
      if (this.trainData && this.trainData.currentTerminal) {
        this.currentTerminalValue = this.getTerminalInfo(commonopsPicklist, this.trainData.currentTerminal.trim().toUpperCase());
      }
      if (this.trainData && this.trainData.nextTerminal) {
        this.nextTerminalValue = this.getTerminalInfo(commonopsPicklist, this.trainData.nextTerminal.trim().toUpperCase());
      }
      if (this.trainData && this.trainData.destinationTerminal) {
        this.destinationTerminalValue = this.getTerminalInfo(commonopsPicklist, this.trainData.destinationTerminal.trim().toUpperCase());
      }
    }

  }

  /**
   * Clean the state of lifecycle hook.
   * @memberOf LmsTrainRouteComponent
   */
  ngOnDestroy() {
  }

  /**
   * Get terminal mnemonic, city and state
   * @param {*} commonopsPicklist
   * @param {string} terminalMnemonic
   * @returns {string}
   * @memberOf LmsTrainRouteComponent
   */
  getTerminalInfo(commonopsPicklist: any, terminalMnemonic: string): string {
    let tMnemonic = terminalMnemonic;
    const terminalCommonInfo: TerminalCommonInfo = this.appUtilityService.getTerminalInfoObject(terminalMnemonic);
    if (terminalCommonInfo && terminalCommonInfo.city) {
      tMnemonic = ' - ' + terminalCommonInfo.city;
    }
    if (terminalCommonInfo && terminalCommonInfo.city && terminalCommonInfo.stateCode) {
      tMnemonic = tMnemonic + ', ' + terminalCommonInfo.stateCode;
    }
    return tMnemonic;
  }

  /**
   * Crew Information
   * @memberof LmsTrainRouteComponent
   */
  getCrewInformation() {
    if (this.trainData) {
      if (this.trainData.currentCrewCalledForTime) {
        this.currentCrewTime = this.trainData.currentCrewCalledForTime;
        this.currentCrewLabel = 'Crew Called for :';
      } else if (this.trainData.currentCrewOnDutyTime) {
        this.currentCrewTime = this.trainData.currentCrewOnDutyTime;
        this.currentCrewLabel = 'Crew On Duty :';
      } else if (this.trainData.currentCrewProjectedForTime) {
        this.currentCrewTime = this.trainData.currentCrewProjectedForTime;
        this.currentCrewLabel = 'Crew Projected for :';
      } else if (this.trainData.currentCrewRequestedForTime) {
        this.currentCrewTime = this.trainData.currentCrewRequestedForTime;
        this.currentCrewLabel = 'Crew Requested for :';
      }
      if (this.trainData.nextCrewCalledForTime) {
        this.nextCrewTime = this.trainData.nextCrewCalledForTime;
        this.nextCrewLabel = 'Crew Called for :';
      } else if (this.trainData.nextCrewOnDutyTime) {
        this.nextCrewTime = this.trainData.nextCrewOnDutyTime;
        this.nextCrewLabel = 'Crew On Duty :';
      } else if (this.trainData.nextCrewProjectedForTime) {
        this.nextCrewTime = this.trainData.nextCrewProjectedForTime;
        this.nextCrewLabel = 'Crew Projected for :';
      } else if (this.trainData.nextCrewRequestedForTime) {
        this.nextCrewTime = this.trainData.nextCrewRequestedForTime;
        this.nextCrewLabel = 'Crew Requested for :';
      }
    }
  }

  /**
   * Check whether next and Destination are same or not
   * @memberof LmsTrainRouteComponent
   */
  checkNextDestinationSame() {
    if (this.trainData) {
      if (this.trainData.nextTerminal === this.trainData.destinationTerminal && this.trainData.etaDestination === this.trainData.etaDateTime) {
        this.isNextDestinationSame = true;
      } else {
        this.isNextDestinationSame = false;
      }
    }
  }

}
